const _A = "Arn";
const _ADL = "AuxiliaryDataLocation";
const _AS = "AppliedSettings";
const _AT = "AppliedTerminology";
const _ATL = "AppliedTerminologyList";
const _ATp = "AppliedTerminologies";
const _B = "Brevity";
const _C = "Content";
const _CA = "CreatedAt";
const _CE = "ConflictException";
const _CME = "ConcurrentModificationException";
const _CPD = "CreateParallelData";
const _CPDR = "CreateParallelDataRequest";
const _CPDRr = "CreateParallelDataResponse";
const _CT = "ClientToken";
const _CTo = "ContentType";
const _D = "Description";
const _DARA = "DataAccessRoleArn";
const _DC = "DocumentContent";
const _DL = "DataLocation";
const _DLC = "DetectedLanguageCode";
const _DLCi = "DisplayLanguageCode";
const _DLLCE = "DetectedLanguageLowConfidenceException";
const _DPD = "DeleteParallelData";
const _DPDR = "DeleteParallelDataRequest";
const _DPDRe = "DeleteParallelDataResponse";
const _DT = "DeleteTerminology";
const _DTR = "DeleteTerminologyRequest";
const _DTTJ = "DescribeTextTranslationJob";
const _DTTJR = "DescribeTextTranslationJobRequest";
const _DTTJRe = "DescribeTextTranslationJobResponse";
const _DWEC = "DocumentsWithErrorsCount";
const _Di = "Directionality";
const _Do = "Document";
const _EK = "EncryptionKey";
const _ET = "EndTime";
const _F = "Filter";
const _FRC = "FailedRecordCount";
const _Fi = "File";
const _Fo = "Format";
const _For = "Formality";
const _GPD = "GetParallelData";
const _GPDR = "GetParallelDataRequest";
const _GPDRe = "GetParallelDataResponse";
const _GT = "GetTerminology";
const _GTR = "GetTerminologyRequest";
const _GTRe = "GetTerminologyResponse";
const _I = "Id";
const _IDC = "InputDataConfig";
const _IDCn = "InputDocumentsCount";
const _IDS = "ImportedDataSize";
const _IFE = "InvalidFilterException";
const _IPVE = "InvalidParameterValueException";
const _IRC = "ImportedRecordCount";
const _IRE = "InvalidRequestException";
const _ISE = "InternalServerException";
const _IT = "ImportTerminology";
const _ITR = "ImportTerminologyRequest";
const _ITRm = "ImportTerminologyResponse";
const _JD = "JobDetails";
const _JI = "JobId";
const _JN = "JobName";
const _JS = "JobStatus";
const _K = "Key";
const _L = "Language";
const _LC = "LanguageCode";
const _LEE = "LimitExceededException";
const _LL = "LanguagesList";
const _LLR = "ListLanguagesRequest";
const _LLRi = "ListLanguagesResponse";
const _LLi = "ListLanguages";
const _LN = "LanguageName";
const _LPD = "ListParallelData";
const _LPDR = "ListParallelDataRequest";
const _LPDRi = "ListParallelDataResponse";
const _LT = "ListTerminologies";
const _LTFR = "ListTagsForResource";
const _LTFRR = "ListTagsForResourceRequest";
const _LTFRRi = "ListTagsForResourceResponse";
const _LTR = "ListTerminologiesRequest";
const _LTRi = "ListTerminologiesResponse";
const _LTTJ = "ListTextTranslationJobs";
const _LTTJR = "ListTextTranslationJobsRequest";
const _LTTJRi = "ListTextTranslationJobsResponse";
const _LUA = "LastUpdatedAt";
const _LUAA = "LatestUpdateAttemptAt";
const _LUAADL = "LatestUpdateAttemptAuxiliaryDataLocation";
const _LUAS = "LatestUpdateAttemptStatus";
const _La = "Languages";
const _Lo = "Location";
const _M = "Message";
const _MR = "MaxResults";
const _MS = "MergeStrategy";
const _N = "Name";
const _NT = "NextToken";
const _ODC = "OutputDataConfig";
const _P = "Profanity";
const _PDC = "ParallelDataConfig";
const _PDDL = "ParallelDataDataLocation";
const _PDN = "ParallelDataNames";
const _PDP = "ParallelDataProperties";
const _PDPL = "ParallelDataPropertiesList";
const _RA = "ResourceArn";
const _RNFE = "ResourceNotFoundException";
const _RT = "RepositoryType";
const _S = "Status";
const _SAT = "SubmittedAfterTime";
const _SB = "SizeBytes";
const _SBT = "SubmittedBeforeTime";
const _SLC = "SourceLanguageCode";
const _SRC = "SkippedRecordCount";
const _ST = "SourceText";
const _STC = "SkippedTermCount";
const _STTJ = "StartTextTranslationJob";
const _STTJR = "StartTextTranslationJobRequest";
const _STTJRt = "StartTextTranslationJobResponse";
const _STTJRto = "StopTextTranslationJobRequest";
const _STTJRtop = "StopTextTranslationJobResponse";
const _STTJt = "StopTextTranslationJob";
const _STu = "SubmittedTime";
const _SU = "S3Uri";
const _SUE = "ServiceUnavailableException";
const _Se = "Settings";
const _T = "Terms";
const _TC = "TermCount";
const _TD = "TerminologyData";
const _TDC = "TranslatedDocumentContent";
const _TDCr = "TranslatedDocumentsCount";
const _TDF = "TerminologyDataFormat";
const _TDL = "TerminologyDataLocation";
const _TDR = "TranslateDocumentRequest";
const _TDRr = "TranslateDocumentResponse";
const _TDr = "TranslatedDocument";
const _TDra = "TranslateDocument";
const _TF = "TerminologyFile";
const _TK = "TagKeys";
const _TL = "TagList";
const _TLC = "TargetLanguageCodes";
const _TLCa = "TargetLanguageCode";
const _TLe = "TermList";
const _TMRE = "TooManyRequestsException";
const _TMTE = "TooManyTagsException";
const _TN = "TerminologyNames";
const _TP = "TerminologyProperties";
const _TPL = "TerminologyPropertiesList";
const _TR = "TagResource";
const _TRR = "TagResourceRequest";
const _TRRa = "TagResourceResponse";
const _TS = "TranslationSettings";
const _TSLEE = "TextSizeLimitExceededException";
const _TT = "TargetText";
const _TTJF = "TextTranslationJobFilter";
const _TTJP = "TextTranslationJobProperties";
const _TTJPL = "TextTranslationJobPropertiesList";
const _TTR = "TranslateTextRequest";
const _TTRr = "TranslateTextResponse";
const _TTr = "TranslatedText";
const _TTra = "TranslateText";
const _Ta = "Tags";
const _Tag = "Tag";
const _Te = "Term";
const _Tex = "Text";
const _Ty = "Type";
const _UDLCE = "UnsupportedDisplayLanguageCodeException";
const _ULPE = "UnsupportedLanguagePairException";
const _UPD = "UpdateParallelData";
const _UPDR = "UpdateParallelDataRequest";
const _UPDRp = "UpdateParallelDataResponse";
const _UR = "UntagResource";
const _URR = "UntagResourceRequest";
const _URRn = "UntagResourceResponse";
const _V = "Value";
const _c = "client";
const _e = "error";
const _hE = "httpError";
const _m = "message";
const _s = "server";
const _sm = "smithy.ts.sdk.synthetic.com.amazonaws.translate";
const n0 = "com.amazonaws.translate";
import { TypeRegistry } from "@smithy/core/schema";
import { ConcurrentModificationException as __ConcurrentModificationException, ConflictException as __ConflictException, DetectedLanguageLowConfidenceException as __DetectedLanguageLowConfidenceException, InternalServerException as __InternalServerException, InvalidFilterException as __InvalidFilterException, InvalidParameterValueException as __InvalidParameterValueException, InvalidRequestException as __InvalidRequestException, LimitExceededException as __LimitExceededException, ResourceNotFoundException as __ResourceNotFoundException, ServiceUnavailableException as __ServiceUnavailableException, TextSizeLimitExceededException as __TextSizeLimitExceededException, TooManyRequestsException as __TooManyRequestsException, TooManyTagsException as __TooManyTagsException, UnsupportedDisplayLanguageCodeException as __UnsupportedDisplayLanguageCodeException, UnsupportedLanguagePairException as __UnsupportedLanguagePairException, } from "../models/index";
import { TranslateServiceException as __TranslateServiceException } from "../models/TranslateServiceException";
export var DocumentContent = [0, n0, _DC, 8, 21];
export var TerminologyFile = [0, n0, _TF, 8, 21];
export var TranslatedDocumentContent = [0, n0, _TDC, 8, 21];
export var AppliedTerminology = [3, n0, _AT, 0, [_N, _T], [0, () => TermList]];
export var ConcurrentModificationException = [
    -3,
    n0,
    _CME,
    {
        [_e]: _c,
        [_hE]: 409,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(ConcurrentModificationException, __ConcurrentModificationException);
export var ConflictException = [
    -3,
    n0,
    _CE,
    {
        [_e]: _c,
        [_hE]: 409,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(ConflictException, __ConflictException);
export var CreateParallelDataRequest = [
    3,
    n0,
    _CPDR,
    0,
    [_N, _D, _PDC, _EK, _CT, _Ta],
    [0, 0, () => ParallelDataConfig, () => EncryptionKey, [0, 4], () => TagList],
];
export var CreateParallelDataResponse = [3, n0, _CPDRr, 0, [_N, _S], [0, 0]];
export var DeleteParallelDataRequest = [3, n0, _DPDR, 0, [_N], [0]];
export var DeleteParallelDataResponse = [3, n0, _DPDRe, 0, [_N, _S], [0, 0]];
export var DeleteTerminologyRequest = [3, n0, _DTR, 0, [_N], [0]];
export var DescribeTextTranslationJobRequest = [3, n0, _DTTJR, 0, [_JI], [0]];
export var DescribeTextTranslationJobResponse = [
    3,
    n0,
    _DTTJRe,
    0,
    [_TTJP],
    [() => TextTranslationJobProperties],
];
export var DetectedLanguageLowConfidenceException = [
    -3,
    n0,
    _DLLCE,
    {
        [_e]: _c,
        [_hE]: 400,
    },
    [_M, _DLC],
    [0, 0],
];
TypeRegistry.for(n0).registerError(DetectedLanguageLowConfidenceException, __DetectedLanguageLowConfidenceException);
export var Document = [3, n0, _Do, 0, [_C, _CTo], [[() => DocumentContent, 0], 0]];
export var EncryptionKey = [3, n0, _EK, 0, [_Ty, _I], [0, 0]];
export var GetParallelDataRequest = [3, n0, _GPDR, 0, [_N], [0]];
export var GetParallelDataResponse = [
    3,
    n0,
    _GPDRe,
    0,
    [_PDP, _DL, _ADL, _LUAADL],
    [
        () => ParallelDataProperties,
        () => ParallelDataDataLocation,
        () => ParallelDataDataLocation,
        () => ParallelDataDataLocation,
    ],
];
export var GetTerminologyRequest = [3, n0, _GTR, 0, [_N, _TDF], [0, 0]];
export var GetTerminologyResponse = [
    3,
    n0,
    _GTRe,
    0,
    [_TP, _TDL, _ADL],
    [() => TerminologyProperties, () => TerminologyDataLocation, () => TerminologyDataLocation],
];
export var ImportTerminologyRequest = [
    3,
    n0,
    _ITR,
    0,
    [_N, _MS, _D, _TD, _EK, _Ta],
    [0, 0, 0, [() => TerminologyData, 0], () => EncryptionKey, () => TagList],
];
export var ImportTerminologyResponse = [
    3,
    n0,
    _ITRm,
    0,
    [_TP, _ADL],
    [() => TerminologyProperties, () => TerminologyDataLocation],
];
export var InputDataConfig = [3, n0, _IDC, 0, [_SU, _CTo], [0, 0]];
export var InternalServerException = [
    -3,
    n0,
    _ISE,
    {
        [_e]: _s,
        [_hE]: 500,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(InternalServerException, __InternalServerException);
export var InvalidFilterException = [
    -3,
    n0,
    _IFE,
    {
        [_e]: _c,
        [_hE]: 400,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(InvalidFilterException, __InvalidFilterException);
export var InvalidParameterValueException = [
    -3,
    n0,
    _IPVE,
    {
        [_e]: _c,
        [_hE]: 400,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(InvalidParameterValueException, __InvalidParameterValueException);
export var InvalidRequestException = [
    -3,
    n0,
    _IRE,
    {
        [_e]: _c,
        [_hE]: 400,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(InvalidRequestException, __InvalidRequestException);
export var JobDetails = [3, n0, _JD, 0, [_TDCr, _DWEC, _IDCn], [1, 1, 1]];
export var Language = [3, n0, _L, 0, [_LN, _LC], [0, 0]];
export var LimitExceededException = [
    -3,
    n0,
    _LEE,
    {
        [_e]: _c,
        [_hE]: 400,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(LimitExceededException, __LimitExceededException);
export var ListLanguagesRequest = [3, n0, _LLR, 0, [_DLCi, _NT, _MR], [0, 0, 1]];
export var ListLanguagesResponse = [
    3,
    n0,
    _LLRi,
    0,
    [_La, _DLCi, _NT],
    [() => LanguagesList, 0, 0],
];
export var ListParallelDataRequest = [3, n0, _LPDR, 0, [_NT, _MR], [0, 1]];
export var ListParallelDataResponse = [
    3,
    n0,
    _LPDRi,
    0,
    [_PDPL, _NT],
    [() => ParallelDataPropertiesList, 0],
];
export var ListTagsForResourceRequest = [3, n0, _LTFRR, 0, [_RA], [0]];
export var ListTagsForResourceResponse = [3, n0, _LTFRRi, 0, [_Ta], [() => TagList]];
export var ListTerminologiesRequest = [3, n0, _LTR, 0, [_NT, _MR], [0, 1]];
export var ListTerminologiesResponse = [
    3,
    n0,
    _LTRi,
    0,
    [_TPL, _NT],
    [() => TerminologyPropertiesList, 0],
];
export var ListTextTranslationJobsRequest = [
    3,
    n0,
    _LTTJR,
    0,
    [_F, _NT, _MR],
    [() => TextTranslationJobFilter, 0, 1],
];
export var ListTextTranslationJobsResponse = [
    3,
    n0,
    _LTTJRi,
    0,
    [_TTJPL, _NT],
    [() => TextTranslationJobPropertiesList, 0],
];
export var OutputDataConfig = [3, n0, _ODC, 0, [_SU, _EK], [0, () => EncryptionKey]];
export var ParallelDataConfig = [3, n0, _PDC, 0, [_SU, _Fo], [0, 0]];
export var ParallelDataDataLocation = [3, n0, _PDDL, 0, [_RT, _Lo], [0, 0]];
export var ParallelDataProperties = [
    3,
    n0,
    _PDP,
    0,
    [_N, _A, _D, _S, _SLC, _TLC, _PDC, _M, _IDS, _IRC, _FRC, _SRC, _EK, _CA, _LUA, _LUAS, _LUAA],
    [0, 0, 0, 0, 0, 64 | 0, () => ParallelDataConfig, 0, 1, 1, 1, 1, () => EncryptionKey, 4, 4, 0, 4],
];
export var ResourceNotFoundException = [
    -3,
    n0,
    _RNFE,
    {
        [_e]: _c,
        [_hE]: 404,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(ResourceNotFoundException, __ResourceNotFoundException);
export var ServiceUnavailableException = [
    -3,
    n0,
    _SUE,
    {
        [_e]: _s,
        [_hE]: 503,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(ServiceUnavailableException, __ServiceUnavailableException);
export var StartTextTranslationJobRequest = [
    3,
    n0,
    _STTJR,
    0,
    [_JN, _IDC, _ODC, _DARA, _SLC, _TLC, _TN, _PDN, _CT, _Se],
    [0, () => InputDataConfig, () => OutputDataConfig, 0, 0, 64 | 0, 64 | 0, 64 | 0, [0, 4], () => TranslationSettings],
];
export var StartTextTranslationJobResponse = [3, n0, _STTJRt, 0, [_JI, _JS], [0, 0]];
export var StopTextTranslationJobRequest = [3, n0, _STTJRto, 0, [_JI], [0]];
export var StopTextTranslationJobResponse = [3, n0, _STTJRtop, 0, [_JI, _JS], [0, 0]];
export var Tag = [3, n0, _Tag, 0, [_K, _V], [0, 0]];
export var TagResourceRequest = [3, n0, _TRR, 0, [_RA, _Ta], [0, () => TagList]];
export var TagResourceResponse = [3, n0, _TRRa, 0, [], []];
export var Term = [3, n0, _Te, 0, [_ST, _TT], [0, 0]];
export var TerminologyData = [
    3,
    n0,
    _TD,
    0,
    [_Fi, _Fo, _Di],
    [[() => TerminologyFile, 0], 0, 0],
];
export var TerminologyDataLocation = [3, n0, _TDL, 0, [_RT, _Lo], [0, 0]];
export var TerminologyProperties = [
    3,
    n0,
    _TP,
    0,
    [_N, _D, _A, _SLC, _TLC, _EK, _SB, _TC, _CA, _LUA, _Di, _M, _STC, _Fo],
    [0, 0, 0, 0, 64 | 0, () => EncryptionKey, 1, 1, 4, 4, 0, 0, 1, 0],
];
export var TextSizeLimitExceededException = [
    -3,
    n0,
    _TSLEE,
    {
        [_e]: _c,
        [_hE]: 400,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(TextSizeLimitExceededException, __TextSizeLimitExceededException);
export var TextTranslationJobFilter = [3, n0, _TTJF, 0, [_JN, _JS, _SBT, _SAT], [0, 0, 4, 4]];
export var TextTranslationJobProperties = [
    3,
    n0,
    _TTJP,
    0,
    [_JI, _JN, _JS, _JD, _SLC, _TLC, _TN, _PDN, _M, _STu, _ET, _IDC, _ODC, _DARA, _Se],
    [
        0,
        0,
        0,
        () => JobDetails,
        0,
        64 | 0,
        64 | 0,
        64 | 0,
        0,
        4,
        4,
        () => InputDataConfig,
        () => OutputDataConfig,
        0,
        () => TranslationSettings,
    ],
];
export var TooManyRequestsException = [
    -3,
    n0,
    _TMRE,
    {
        [_e]: _c,
        [_hE]: 429,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(TooManyRequestsException, __TooManyRequestsException);
export var TooManyTagsException = [
    -3,
    n0,
    _TMTE,
    {
        [_e]: _c,
        [_hE]: 400,
    },
    [_m, _RA],
    [0, 0],
];
TypeRegistry.for(n0).registerError(TooManyTagsException, __TooManyTagsException);
export var TranslatedDocument = [3, n0, _TDr, 0, [_C], [[() => TranslatedDocumentContent, 0]]];
export var TranslateDocumentRequest = [
    3,
    n0,
    _TDR,
    0,
    [_Do, _TN, _SLC, _TLCa, _Se],
    [[() => Document, 0], 64 | 0, 0, 0, () => TranslationSettings],
];
export var TranslateDocumentResponse = [
    3,
    n0,
    _TDRr,
    0,
    [_TDr, _SLC, _TLCa, _ATp, _AS],
    [[() => TranslatedDocument, 0], 0, 0, () => AppliedTerminologyList, () => TranslationSettings],
];
export var TranslateTextRequest = [
    3,
    n0,
    _TTR,
    0,
    [_Tex, _TN, _SLC, _TLCa, _Se],
    [0, 64 | 0, 0, 0, () => TranslationSettings],
];
export var TranslateTextResponse = [
    3,
    n0,
    _TTRr,
    0,
    [_TTr, _SLC, _TLCa, _ATp, _AS],
    [0, 0, 0, () => AppliedTerminologyList, () => TranslationSettings],
];
export var TranslationSettings = [3, n0, _TS, 0, [_For, _P, _B], [0, 0, 0]];
export var UnsupportedDisplayLanguageCodeException = [
    -3,
    n0,
    _UDLCE,
    {
        [_e]: _c,
        [_hE]: 400,
    },
    [_M, _DLCi],
    [0, 0],
];
TypeRegistry.for(n0).registerError(UnsupportedDisplayLanguageCodeException, __UnsupportedDisplayLanguageCodeException);
export var UnsupportedLanguagePairException = [
    -3,
    n0,
    _ULPE,
    {
        [_e]: _c,
        [_hE]: 400,
    },
    [_M, _SLC, _TLCa],
    [0, 0, 0],
];
TypeRegistry.for(n0).registerError(UnsupportedLanguagePairException, __UnsupportedLanguagePairException);
export var UntagResourceRequest = [3, n0, _URR, 0, [_RA, _TK], [0, 64 | 0]];
export var UntagResourceResponse = [3, n0, _URRn, 0, [], []];
export var UpdateParallelDataRequest = [
    3,
    n0,
    _UPDR,
    0,
    [_N, _D, _PDC, _CT],
    [0, 0, () => ParallelDataConfig, [0, 4]],
];
export var UpdateParallelDataResponse = [3, n0, _UPDRp, 0, [_N, _S, _LUAS, _LUAA], [0, 0, 0, 4]];
export var __Unit = "unit";
export var TranslateServiceException = [-3, _sm, "TranslateServiceException", 0, [], []];
TypeRegistry.for(_sm).registerError(TranslateServiceException, __TranslateServiceException);
export var AppliedTerminologyList = [1, n0, _ATL, 0, () => AppliedTerminology];
export var LanguageCodeStringList = 64 | 0;
export var LanguagesList = [1, n0, _LL, 0, () => Language];
export var ParallelDataPropertiesList = [1, n0, _PDPL, 0, () => ParallelDataProperties];
export var ResourceNameList = 64 | 0;
export var TagKeyList = 64 | 0;
export var TagList = [1, n0, _TL, 0, () => Tag];
export var TargetLanguageCodeStringList = 64 | 0;
export var TerminologyPropertiesList = [1, n0, _TPL, 0, () => TerminologyProperties];
export var TermList = [1, n0, _TLe, 0, () => Term];
export var TextTranslationJobPropertiesList = [1, n0, _TTJPL, 0, () => TextTranslationJobProperties];
export var CreateParallelData = [
    9,
    n0,
    _CPD,
    0,
    () => CreateParallelDataRequest,
    () => CreateParallelDataResponse,
];
export var DeleteParallelData = [
    9,
    n0,
    _DPD,
    0,
    () => DeleteParallelDataRequest,
    () => DeleteParallelDataResponse,
];
export var DeleteTerminology = [9, n0, _DT, 0, () => DeleteTerminologyRequest, () => __Unit];
export var DescribeTextTranslationJob = [
    9,
    n0,
    _DTTJ,
    0,
    () => DescribeTextTranslationJobRequest,
    () => DescribeTextTranslationJobResponse,
];
export var GetParallelData = [
    9,
    n0,
    _GPD,
    0,
    () => GetParallelDataRequest,
    () => GetParallelDataResponse,
];
export var GetTerminology = [
    9,
    n0,
    _GT,
    0,
    () => GetTerminologyRequest,
    () => GetTerminologyResponse,
];
export var ImportTerminology = [
    9,
    n0,
    _IT,
    0,
    () => ImportTerminologyRequest,
    () => ImportTerminologyResponse,
];
export var ListLanguages = [
    9,
    n0,
    _LLi,
    0,
    () => ListLanguagesRequest,
    () => ListLanguagesResponse,
];
export var ListParallelData = [
    9,
    n0,
    _LPD,
    0,
    () => ListParallelDataRequest,
    () => ListParallelDataResponse,
];
export var ListTagsForResource = [
    9,
    n0,
    _LTFR,
    0,
    () => ListTagsForResourceRequest,
    () => ListTagsForResourceResponse,
];
export var ListTerminologies = [
    9,
    n0,
    _LT,
    0,
    () => ListTerminologiesRequest,
    () => ListTerminologiesResponse,
];
export var ListTextTranslationJobs = [
    9,
    n0,
    _LTTJ,
    0,
    () => ListTextTranslationJobsRequest,
    () => ListTextTranslationJobsResponse,
];
export var StartTextTranslationJob = [
    9,
    n0,
    _STTJ,
    0,
    () => StartTextTranslationJobRequest,
    () => StartTextTranslationJobResponse,
];
export var StopTextTranslationJob = [
    9,
    n0,
    _STTJt,
    0,
    () => StopTextTranslationJobRequest,
    () => StopTextTranslationJobResponse,
];
export var TagResource = [9, n0, _TR, 0, () => TagResourceRequest, () => TagResourceResponse];
export var TranslateDocument = [
    9,
    n0,
    _TDra,
    0,
    () => TranslateDocumentRequest,
    () => TranslateDocumentResponse,
];
export var TranslateText = [
    9,
    n0,
    _TTra,
    0,
    () => TranslateTextRequest,
    () => TranslateTextResponse,
];
export var UntagResource = [
    9,
    n0,
    _UR,
    0,
    () => UntagResourceRequest,
    () => UntagResourceResponse,
];
export var UpdateParallelData = [
    9,
    n0,
    _UPD,
    0,
    () => UpdateParallelDataRequest,
    () => UpdateParallelDataResponse,
];
